module.exports = __webpack_public_path__ + "media/images/TaslerIT_Logo-Sign_blk-d6ce74e96a1c0a283a273cf24c43feff.svg";